import api from '@/utils/api';

export default {
  getAllReview: ({ token, id }) => api.get(`/notify/${id}`, { headers: { Authorization: `Bearer ${token}` } }),
  getAllNotify: ({ token, id }) => api.get(`/notify/${id}`, { headers: { Authorization: `Bearer ${token}` } }),
  addNotify: ({ token, notify }) => api.post('/notify/', notify, { headers: { Authorization: `Bearer ${token}` } }),
  updateNotify: ({ token, id, status }) => api.put(`/notify/${id}`, status, { headers: { Authorization: `Bearer ${token}` } }),
};
